import React from 'react';
import StarRating from '@homeaway/react-star-rating';

import {InstantBookableSVG} from '../listings/InstantBookableSVG';
import CardPrice from './CardPrice';
import CardDescription from './CardDescription';
import ReviewCount from './ReviewCount';

export function CommonDescription({instantBookable, price, review}) {
    return (
        <div className="CommonDescription__container">
            {instantBookable ? (
                <InstantBookableSVG svgTitle={instantBookable} />
            ) : null}
            <CardPrice price={price} />
            <div className={'CommonRatioCard__review'}>
                {review.averageRating ? (
                    <StarRating rating={review.averageRating} size={'12'} />
                ) : null}
                {<ReviewCount count={review.reviewCount} />}
            </div>
        </div>
    );
}

export function listingCaption({toplineDescription = ''}) {
    return (
        <h4
            className={'CommonRatioCard__caption'}
            data-slot={'caption'}
            key={'caption'}
        >
            <CardDescription text={toplineDescription} />
        </h4>
    );
}
